import editorialSearchesStore from '@/utils/searches_store/editorial'
import { redirectWithoutNavigationGuardError } from './base'

export default ({ redirect, route }) => {
  if(route.params.date) return

  const filters = editorialSearchesStore.read()
  if (filters && filters.selectedDate) {
    redirectWithoutNavigationGuardError(redirect, { path: `/editorials/${filters.selectedDate}` })
  }
}